import GithubUSer from "./components/github-user";


function App() {
  return (
    <div className=" ">
        <GithubUSer/>
    </div>
  );
}

export default App;
